<template>
  <div class="d-flex flex-column flex-grow-1 mr-2 mb-2 rounded">
    <BaseToolBar
      title="Fournisseur"
      subtitle="Liste des fournisseurs disponibles"
    >
      <BaseButton
        class="btn btn-primary ml-3"
        v-tooltip="'Exporter'"
        @click="exportFournisseurs"
        :loading="loading"
        text="Exporter(.xls)"
      ></BaseButton>

      <BaseButton
        class="btn btn-primary ml-3"
        v-tooltip="'Exporter les evals'"
        @click="exportEvalFournisseurs"
        :loading="loading"
        text="Exporter eval(.xls)"
      ></BaseButton>

      <BaseButton
        v-if="havePermission('add_materiels_fournisseurs')"
        class="btn btn-primary ml-3"
        v-tooltip="'Ajouter un fournisseur'"
        @click="storeFournisseur"
        :loading="loading"
        icon="plus"
        text="Ajouter"
      ></BaseButton>
    </BaseToolBar>

    <!-- Ajout du champ de recherche -->
    <div class="mb-3">
      <div class="input-group">
        <input-search
          class="mt-3"
          text="Rechercher..."
          v-model="searchQuery"
          :showResults="false"
          @reset="searchQuery = ''"
          @input="filterResults"
        ></input-search>
      </div>
    </div>

    <div class="d-flex mb-3">
      <div class="cursor-pointer mr-3" @click="tab = 1" v-color-1="tab == 1">
        Actifs
      </div>
      <div class="cursor-pointer mr-3" @click="tab = 0" v-color-1="tab == 0">
        Inactifs
      </div>

      <div class="cursor-pointer mr-3" @click="tab = 2" v-color-1="tab == 2">
        Agréés
      </div>
      <div class="cursor-pointer mr-3" @click="tab = 3" v-color-1="tab == 3">
        Non agréés
      </div>
      <div class="cursor-pointer" @click="tab = 4" v-color-1="tab == 4">
        En cours
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row w-100">
      <div class="flex-grow-1 d-flex flex-column">
        <div
          v-for="fournisseur in filteredFournisseursNew"
          :key="'news_' + fournisseur.id"
        >
          <fournisseurs-item
            :fournisseur="fournisseur"
            :canDelete="canDelete"
            :canUpdate="canUpdate"
          ></fournisseurs-item>
        </div>
        <div v-if="tab == 1">
          <div
            v-for="fournisseur in filteredFournisseursActif"
            :key="'actives_' + fournisseur.id"
          >
            <fournisseurs-item
              :fournisseur="fournisseur"
              :canDelete="canDelete"
              :canUpdate="canUpdate"
            ></fournisseurs-item>
          </div>
        </div>
        <div v-if="tab == 0">
          <div
            v-for="fournisseur in filteredFournisseursInactif"
            :key="'inactives_' + fournisseur.id"
          >
            <fournisseurs-item :fournisseur="fournisseur"></fournisseurs-item>
          </div>
        </div>

        <div v-if="tab == 2">
          <div
            v-for="fournisseur in filteredFournisseursAgree"
            :key="'agree_' + fournisseur.id"
          >
            <fournisseurs-item :fournisseur="fournisseur"></fournisseurs-item>
          </div>
        </div>

        <div v-if="tab == 3">
          <div
            v-for="fournisseur in filteredFournisseursNonAgree"
            :key="'nonagree_' + fournisseur.id"
          >
            <fournisseurs-item :fournisseur="fournisseur"></fournisseurs-item>
          </div>
        </div>

        <div v-if="tab == 4">
          <div
            v-for="fournisseur in filteredFournisseursSousTraitant"
            :key="'soustraitant_' + fournisseur.id"
          >
            <fournisseurs-item :fournisseur="fournisseur"></fournisseurs-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import FournisseursItem from "@/components/fournisseurs/FournisseursItem.vue";
import BaseButton from "@/components/bases/Button.vue";
import BaseToolBar from "@/components/bases/ToolBar.vue";

import InputSearch from "@/components/bases/InputSearch.vue";

export default {
  components: {
    BaseToolBar,
    BaseButton,
    FournisseursItem,
    InputSearch
  },
  data() {
    return {
      loading: false,
      feedback: {},
      tab: 1,
      searchQuery: "",
      filteredFournisseurs: []
    };
  },
  methods: {
    ...mapActions({
      _storeFournisseur: "materiel/createFournisseur"
    }),
    storeFournisseur: function() {
      this.feedback = {};
      this.loading = true;
      this._storeFournisseur().finally(() => window.location.reload());
    },
    exportFournisseurs() {
      this.loading = true;
      this.$http
        .get("/materiels/fournisseur-export")
        .then(response => {
          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(response.data);
          anchor.target = "_blank";
          anchor.download = "export-fournisseurs.csv";
          anchor.click();
        })
        .finally(() => (this.loading = false));
    },
    exportEvalFournisseurs() {
      this.loading = true;
      this.$http
        .get("/materiels/fournisseur-eval-export")
        .then(response => {
          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(response.data);
          anchor.target = "_blank";
          anchor.download = "export-fournisseurs-eval.csv";
          anchor.click();
        })
        .finally(() => (this.loading = false));
    },
    filterResults() {
      // Cette méthode est déclenchée à chaque fois que l'utilisateur tape dans le champ de recherche
      // Elle n'est pas strictement nécessaire car les computed properties font déjà le filtrage
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({ havePermission: "user/havePermission" }),
    ...mapGetters({ data: "materiel/data" }),
    ...mapMultiRowFields("materiel", ["fournisseurs"]),
    ...mapMultiRowFields("materiel", ["evaluations"]),

    // Listes de fournisseurs de base
    fournisseursNew: function() {
      return this.fournisseurs.filter(fournisseur => fournisseur.new == true);
    },
    fournisseursActif: function() {
      return this.fournisseurs.filter(fournisseur => fournisseur.etat == 1);
    },
    fournisseursInactif: function() {
      return this.fournisseurs.filter(fournisseur => fournisseur.etat == 0);
    },
    fournisseursAgree: function() {
      return this.fournisseurs.filter(fournisseur => fournisseur.agree == 1);
    },
    fournisseursNonAgree: function() {
      return this.fournisseurs.filter(fournisseur => fournisseur.agree == 0);
    },
    fournisseursSousTraitant: function() {
      return this.fournisseurs.filter(fournisseur => fournisseur.agree == 3);
    },

    // Listes filtrées par la recherche
    filteredFournisseursNew: function() {
      if (!this.searchQuery) return this.fournisseursNew;

      const query = this.searchQuery.toLowerCase();
      return this.fournisseursNew.filter(
        f =>
          (f.description && f.description.toLowerCase().includes(query)) ||
          (f.adresse && f.adresse.toLowerCase().includes(query)) ||
          (f.email && f.email.toLowerCase().includes(query)) ||
          (f.activite && f.activite.toLowerCase().includes(query)) ||
          (f.telephone && f.telephone.toLowerCase().includes(query)) ||
          (f.type_service && f.type_service.toLowerCase().includes(query))
      );
    },
    filteredFournisseursActif: function() {
      if (!this.searchQuery) return this.fournisseursActif;

      const query = this.searchQuery.toLowerCase();
      return this.fournisseursActif.filter(
        f =>
          (f.description && f.description.toLowerCase().includes(query)) ||
          (f.adresse && f.adresse.toLowerCase().includes(query)) ||
          (f.email && f.email.toLowerCase().includes(query)) ||
          (f.activite && f.activite.toLowerCase().includes(query)) ||
          (f.telephone && f.telephone.toLowerCase().includes(query)) ||
          (f.type_service && f.type_service.toLowerCase().includes(query))
      );
    },
    filteredFournisseursInactif: function() {
      if (!this.searchQuery) return this.fournisseursInactif;

      const query = this.searchQuery.toLowerCase();
      return this.fournisseursInactif.filter(
        f =>
          (f.description && f.description.toLowerCase().includes(query)) ||
          (f.adresse && f.adresse.toLowerCase().includes(query)) ||
          (f.email && f.email.toLowerCase().includes(query)) ||
          (f.activite && f.activite.toLowerCase().includes(query)) ||
          (f.telephone && f.telephone.toLowerCase().includes(query)) ||
          (f.type_service && f.type_service.toLowerCase().includes(query))
      );
    },
    filteredFournisseursAgree: function() {
      if (!this.searchQuery) return this.fournisseursAgree;

      const query = this.searchQuery.toLowerCase();
      return this.fournisseursAgree.filter(
        f =>
          (f.description && f.description.toLowerCase().includes(query)) ||
          (f.adresse && f.adresse.toLowerCase().includes(query)) ||
          (f.email && f.email.toLowerCase().includes(query)) ||
          (f.activite && f.activite.toLowerCase().includes(query)) ||
          (f.telephone && f.telephone.toLowerCase().includes(query)) ||
          (f.type_service && f.type_service.toLowerCase().includes(query))
      );
    },
    filteredFournisseursNonAgree: function() {
      if (!this.searchQuery) return this.fournisseursNonAgree;

      const query = this.searchQuery.toLowerCase();
      return this.fournisseursNonAgree.filter(
        f =>
          (f.description && f.description.toLowerCase().includes(query)) ||
          (f.adresse && f.adresse.toLowerCase().includes(query)) ||
          (f.email && f.email.toLowerCase().includes(query)) ||
          (f.activite && f.activite.toLowerCase().includes(query)) ||
          (f.telephone && f.telephone.toLowerCase().includes(query)) ||
          (f.type_service && f.type_service.toLowerCase().includes(query))
      );
    },
    filteredFournisseursSousTraitant: function() {
      if (!this.searchQuery) return this.fournisseursSousTraitant;

      const query = this.searchQuery.toLowerCase();
      return this.fournisseursSousTraitant.filter(
        f =>
          (f.description && f.description.toLowerCase().includes(query)) ||
          (f.adresse && f.adresse.toLowerCase().includes(query)) ||
          (f.email && f.email.toLowerCase().includes(query)) ||
          (f.activite && f.activite.toLowerCase().includes(query)) ||
          (f.telephone && f.telephone.toLowerCase().includes(query)) ||
          (f.type_service && f.type_service.toLowerCase().includes(query))
      );
    },

    canDelete: function() {
      return this.havePermission("del_materiels_fournisseurs") ? true : false;
    },
    canUpdate: function() {
      return this.havePermission("upd_materiels_fournisseurs") ? true : false;
    }
  }
};
</script>

<style lang="css">
.input-group-text {
  background-color: #f8f9fa;
  border-right: none;
}
.form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}
</style>
